module.exports = __webpack_public_path__ + "static/media/digital-tachograph.15d3de9b.svg";